exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n}\n\n.stream-toolbar {\n  -ms-flex-align: center;\n      align-items: center;\n  background: #f6f9fc;\n  border: 1px solid #dbe4ef;\n  border-bottom: 0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  gap: 8px;\n  padding: 10px;\n}\n\n.stream-toolbar div {\n  margin-right: auto;\n}\n\n.stream-toolbar span {\n  color: #587189;\n  display: block;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.stream-toolbar strong {\n  color: #13283c;\n  display: block;\n  font-size: 20px;\n  margin-top: 2px;\n}\n\n.stream-toolbar button {\n  background: #ffffff;\n  border: 1px solid #cbd8e6;\n  border-radius: 4px;\n  color: #1d3d5c;\n  cursor: pointer;\n  font-weight: 700;\n  padding: 8px 12px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /storage/data/github/tests/angular-data-table-component/angular-4/src/app/examples/async-pipe-stream/async-pipe-stream.component.css
// module id = ../../../../../src/app/examples/async-pipe-stream/async-pipe-stream.component.css
// module chunks = main